module.exports = __webpack_public_path__ + "img/logo.5fddb9c7.png";